import { render, staticRenderFns } from "./DangerFileUploadPop.vue?vue&type=template&id=52d34613"
import script from "./DangerFileUploadPop.vue?vue&type=script&lang=js"
export * from "./DangerFileUploadPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d34613')) {
      api.createRecord('52d34613', component.options)
    } else {
      api.reload('52d34613', component.options)
    }
    module.hot.accept("./DangerFileUploadPop.vue?vue&type=template&id=52d34613", function () {
      api.rerender('52d34613', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/DangerFileUploadPop.vue"
export default component.exports